(function () {
  'use strict';
  function syncApprovalReassurance() {
    document.querySelectorAll('[data-pdp-approval-reassurance]').forEach(function (node) {
      const required = node.dataset.approvalAlwaysRequired === 'true' ||
        window.__PDP_ADDON_APPROVAL_REQUIRED__ === true;
      const normal = node.querySelector('[data-pdp-approval-normal]');
      const approval = node.querySelector('[data-pdp-approval-required]');
      if (normal && normal.hidden !== required) normal.hidden = required;
      if (approval && approval.hidden === required) approval.hidden = !required;
    });
  }
  document.addEventListener('pdp:addon-approval-change', syncApprovalReassurance);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncApprovalReassurance, { once: true });
  } else {
    syncApprovalReassurance();
  }
})();
